// extracted by mini-css-extract-plugin
module.exports = {"module":"object-item_module__3dOYX","image":"object-item_image__3GwDr","name":"object-item_name__39ymp"};